import React, { Component } from 'react';
import {connect} from 'react-redux'
import StockTyreEditCategoryModal from './StockTyreEditCategoryModal';
import { HelpBlock, Button, Form, FormControl, FormGroup, ControlLabel, Row, Col, ButtonToolbar } from 'react-bootstrap';
import { Box } from 'reactjs-admin-lte';
import FontAwesome from 'react-fontawesome';
import Select from 'react-select';
import Lightbox from 'react-images';
import IframeModal from 'component/element/IframeModal'
import StockStore from 'stores/StockStore'
import DatePicker from 'component/element/DatePicker'
import './Stock.css';
// import No_img from 'asset/img/no_image.jpg';
var NotificationSystem = require('react-notification-system');

class StockEditTyreModal extends Component {

  constructor(props) {
    super(props)

    this.state = ({
      showCategoryPopup:false,
      cateAdd:'',
      optionsCategory:[],
      optionsSubCategory:[],
      currentImage:0,
      lightboxIsOpen:false,
      dataSet:{},
      images:[],
      loading:false
    })
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    this.setState({dataSet:this.props.dataSet})
    this.loadCategory()
    this.loadSubCategory(this.props.dataSet.cat_id)
    this.loadImg(this.props.dataSet)
  }

//   componentWillReceiveProps(newProps) {
//     if (newProps.show&&newProps.show!==this.props.show) {
//         this.setState({dataSet:newProps.dataSet})
//         this.loadCategory()
//         this.loadSubCategory(newProps.dataSet.cat_id)
//         this.loadImg(newProps.dataSet)
//     }
//   }

  loadImg(dataSet) {
    StockStore.loadImages(this.props.tool,dataSet.itemnum,(result)=>{
        let images = []
        result.data.files.forEach((item,index)=>{
            images.push({
                url: item.url,
                src: item.url,
                thumbnail: item.thumbnailUrl,
                srcset: [item.url],
                caption: item.name
            })
        })
        this.setState({images:images})
    })
  }

  loadCategory() {
    let that = this
    StockStore.loadCategory(this.props.tool, function (result) {
      let dd = [{value:'',label:'----- เลือก -----'}]
      result.data.forEach(function(item,index) {  
        dd.push({
          value: item.cat_id,
          label: item.name
        })
      })
      that.setState({optionsCategory:dd})
    })
  }

  loadSubCategory(value) {
    let that = this
    let dataSubDd = [{label:'----- เลือก -----',value:''}]
    StockStore.loadSubCategory(this.props.tool, value, function (result) {
      result.data.forEach((item,index)=>{
        dataSubDd.push({
          label:item.name,
          value:item.cat_id
        })
      })  
      that.setState({ optionsSubCategory: dataSubDd })
    })
  }

  onCategoryChange(e) {
    let {dataSet} = this.state
    dataSet.cat_id = e.value
    dataSet.subcat_id = ''
    this.setState({dataSet:dataSet})
    this.loadSubCategory(e.value)
  }

  onSubCategoryChange(e) {
    let {dataSet} = this.state
    dataSet.subcat_id = e.value
    this.setState({dataSet:dataSet})
  }

  onCategoryOpenClick(add) {
    this.setState({ showCategoryPopup: true, cateAdd:add })
  }

  onCategoryCloseClick() {
    this.setState({ showCategoryPopup: false, cateAdd:'' })
  }

  onCategorySaveClick() {
    let data = this.refs.categoryPop.getWrappedInstance().getData()
    let that = this
    let {messages} = this.props
    let {cateAdd,dataSet} = this.state
    StockStore.saveTyreCategory(this.props.tool, (cateAdd==='cat_id'?undefined:dataSet.cat_id), data, function (result) {
      if (cateAdd==='cat_id') {
        let optionsCategory = result.data.map((item, index) => {
          return { value: item.cat_id, label: item.name }
        })
        optionsCategory.unshift({value:'',label:'----- เลือก -----'})
        that.setState({ showCate: false, optionsCategory: optionsCategory, cateAdd:'' })
      } else if (cateAdd==='sub_cat_id') {
        let optionsSubCategory = result.data.map((item, index) => {
          return { value: item.cat_id, label: item.name }
        })
        optionsSubCategory.unshift({value:'',label:'----- เลือก -----'})
        that.setState({ showCate: false, optionsSubCategory: optionsSubCategory, cateAdd:'' })
      }    
      this.setState({cateAdd:'',showCategoryPopup:false})
    }, function () {
      that._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: messages['Save Category failed, Please Try Again.'],
        level: 'error',
        position: 'tc'
      });
      this.setState({cateAdd:'',showCategoryPopup:false})
    })
  }

  onUploadClick() {
    let {dataSet} = this.state
    let url = ''
    if (process.env.NODE_ENV === "development") {
      url = 'https://demo-fast.bigfix.co/sriracha/fup/stock.html?cat=' + this.props.stockType + '&itemnum=' + dataSet.itemnum
    } else {
      url = './fup/stock.html?cat=' + this.props.stockType + '&itemnum=' + dataSet.itemnum
    }
    let that = this
    this.refs.iframe.getWrappedInstance().loadUrl(url, function () {
      if (that.props.onImageUpload !== undefined)
        that.props.onImageUpload()
    })
  }

  onImgClick() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: true,
    });
  }

  onTextChange(field,e) {
    let {dataSet} = this.state
    dataSet[field] = e.target.value
    this.setState({dataSet:dataSet})
  }

  onDateChange(field,e) {
    let {dataSet} = this.state
    if (e===''||e===null||e===undefined)
      dataSet[field] = ''
    else
      dataSet[field] = e  
    this.setState({dataSet:dataSet})
  }

  onClickImage() {
    if (this.state.currentImage === this.state.images.length - 1) return
    this.onClickNext()
  }

  onClickNext() {
    this.setState({
      currentImage: this.state.currentImage + 1,
    });
  }

  onClickPrevious() {
    this.setState({
      currentImage: this.state.currentImage - 1,
    });
  }

  onCloseLightbox() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false,
    });
  }

  onNewCategory(cat_id) {
    let {optionsCategory} = this.state
    let key = optionsCategory.findIndex(x=>x.value===cat_id)
    if (key!==-1) {
      optionsCategory.splice(key,1)
      this.setState({optionsCategory:optionsCategory})
    }
    this.props.onNewCategory(cat_id)
  }

  onNewSubCategory(cat_id) {
    let {optionsSubCategory,dataSet} = this.state
    let key = optionsSubCategory.findIndex(x=>x.value===cat_id)
    if (key!==-1) {
      optionsSubCategory.splice(key,1)
      this.setState({optionsSubCategory:optionsSubCategory})
      if (dataSet.subcat_id===cat_id) {
        dataSet.subcat_id = ''
        this.setState({dataSet:dataSet})
      }
    }
  }

  onUpImgHide() {
    this.loadImg(this.state.dataSet)
  }

  renderNewCategoryPopup() {
    let {cateAdd,showCategoryPopup,dataSet} = this.state
    return (
        <StockTyreEditCategoryModal
          show={showCategoryPopup}
          onHide={()=>{this.setState({showCategoryPopup:false,cateAdd:''})}}
          ref='categoryPop'
          catId={dataSet.cat_id}
          cateAdd={cateAdd}
          stockType={this.props.tool}
          onNewCategory={this.onNewCategory.bind(this)}
          onNewSubCategory={this.onNewSubCategory.bind(this)}
          onCategorySaveClick={this.onCategorySaveClick.bind(this)}
        />
    )
  }

  renderImage() {
    let {messages} = this.props
    let {images} = this.state
    if (images.length > 0) {
      return (
        <Row>
          <Col xs={12}>
            <img alt='' src={images[0].url} width="100%" height="100%" />
          </Col>
        </Row>
      )
    } else {
      return (
        <Row>
          <Col xs={6}>
            <img alt='' src={'https://static.bigfix.co/img/no_image.jpg'} width="100%" height="100%" />
          </Col>
          <Col xs={6}>
            <h4 style={{ color: "#337ab7" }}>{messages['Product Image']}</h4>
            <h5>0 {messages['Image']}</h5>
          </Col>
        </Row>
      )
    }
  }

//   onStockEditProductCloseClick() {
//     this.props.onHide()
//   }  

  onProductSaveClick() {
    this.props.onSave()
  }

  render() {
    let {messages} = this.props
    let {dataSet,images} = this.state
    // let title = messages['Add Item']
    // if (dataSet.itemnum) {
    //   title = messages['Edit Item']
    // }

    return (
      <div>
        {/* <Modal id="newTyrePopup" bsSize="large" show={this.props.show} onHide={this.onStockEditProductCloseClick.bind(this)}>
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body> */}
        <Box loading={this.state.loading}>
          <Box.Body>
            <Form>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <ControlLabel>{messages['Category']}</ControlLabel>
                    <Select
                      clearable={false}
                      name="form-field-name"
                      value={this.props.dataSet.cat_id===undefined||this.props.dataSet.cat_id===0||this.props.dataSet.cat_id===null?'':this.props.dataSet.cat_id}
                      options={this.state.optionsCategory}
                      onChange={this.onCategoryChange.bind(this)}
                    />
                    <FormControl.Feedback />
                    <HelpBlock>
                      <Button
                        bsStyle={'box-tool'} 
                        className='btn-box-tool'
                        onClick={this.onCategoryOpenClick.bind(this,'cat_id')}
                      >
                        <FontAwesome name='plus' /> {messages['Add Category']}
                      </Button>
                    </HelpBlock>
                  </FormGroup>
                </Col>  
                <Col md={6}>
                  <FormGroup>
                    <ControlLabel>หมวดย่อย</ControlLabel>
                    <Select
                      clearable={false}
                      name="form-field-name"
                      value={this.props.dataSet.subcat_id===undefined||this.props.dataSet.subcat_id===0||this.props.dataSet.subcat_id===null?'':this.props.dataSet.subcat_id}
                      options={this.state.optionsSubCategory}
                      onChange={this.onSubCategoryChange.bind(this)}
                    />
                    <FormControl.Feedback />
                    <HelpBlock>
                      <Button
                        bsStyle={'box-tool'} 
                        className='btn-box-tool'
                        onClick={this.onCategoryOpenClick.bind(this,'sub_cat_id')}
                      >
                        <FontAwesome name='plus' />&nbsp;เพิ่มหมวดหมู่ย่อย
                      </Button>
                    </HelpBlock>
                  </FormGroup>
                </Col>
              </Row>  
            </Form>
            <div>
              <Row>
                <Col md={6}>
                  <Form>
                    <FormGroup
                      controlId={null}
                      validationState={null}
                    >
                      <ControlLabel>ยี่ห้อ</ControlLabel>
                      <FormControl
                        value={dataSet.tyre_brand}
                        onChange={this.onTextChange.bind(this,'tyre_brand')} 
                      />
                    </FormGroup>
                  </Form>
                </Col>   
                <Col md={6}>
                  <Form> 
                    <FormGroup
                      controlId={null}
                      validationState={null}
                    >
                      <ControlLabel>รุ่น</ControlLabel>
                      <FormControl
                        value={dataSet.tyre_model}
                        onChange={this.onTextChange.bind(this,'tyre_model')} 
                      />
                    </FormGroup>
                  </Form>
                </Col>
              </Row>      
              <Row>
                <Col md={6}>
                  <Form>
                    <FormGroup
                      controlId={null}
                      validationState={null}
                    >
                      <ControlLabel>หมายเลขยาง</ControlLabel>
                      <FormControl value={dataSet.serial_no} onChange={this.onTextChange.bind(this,'serial_no')} />
                    </FormGroup>
                  </Form>
                </Col>
                <Col md={6}>
                  <Form>
                    <FormGroup
                      controlId={null}
                      validationState={null}
                    >
                      <ControlLabel>ขนาดยาง</ControlLabel>
                      <FormControl
                        value={dataSet.tyre_size}
                        onChange={this.onTextChange.bind(this,'tyre_size')} 
                      />
                    </FormGroup>
                  </Form>  
                </Col>    
              </Row> 
              <Row>
                <Col md={6}>
                  <Form>
                    <FormGroup
                      controlId={null}
                      validationState={null}
                    >
                      <ControlLabel>จำนวนครั้งที่หล่อดอก</ControlLabel>
                      <FormControl className='text-center' value={dataSet.retread_count} onChange={this.onTextChange.bind(this,'retread_count')} />
                    </FormGroup>
                  </Form>
                </Col>
                <Col md={6}>
                  <Form>
                    <FormGroup
                      controlId={null}
                      validationState={null}
                    >
                      <ControlLabel>จำนวน กม.</ControlLabel>
                      <FormControl className='text-center' value={dataSet.tyre_mileage} onChange={this.onTextChange.bind(this,'tyre_mileage')} />
                    </FormGroup>
                  </Form>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Form>
                    <FormGroup
                      controlId={null}
                      validationState={null}
                    >
                      <ControlLabel>วันที่วัดดอกยาง</ControlLabel>
                      <DatePicker
                        showIcon={true}
                        showFooter={true}
                        popPlacement='bottom'
                        buddhistEra
                        value={dataSet.treaddepth_date} 
                        maxWidth={'100%'}
                        inline={false}
                        onChange={this.onDateChange.bind(this,'treaddepth_date')}
                      />
                    </FormGroup>
                  </Form>
                </Col>
                <Col md={6}>
                  <Form>
                    <FormGroup
                      controlId={null}
                      validationState={null}
                    >
                      <ControlLabel>ความลึกดอกยางครั้งสุดท้าย</ControlLabel>
                      <FormControl className='text-center' value={dataSet.treaddepth} onChange={this.onTextChange.bind(this,'treaddepth')} />
                    </FormGroup>
                  </Form>
                </Col>
              </Row>  
              <Row>
                <Col md={6}>
                  <Form>
                    <FormGroup
                      controlId={null}
                      validationState={null}
                    >
                      <ControlLabel>วันที่เริ่มใช้ยาง</ControlLabel>
                      <DatePicker
                        showIcon={true}
                        showFooter={true}
                        popPlacement='bottom'
                        buddhistEra
                        value={dataSet.begin_used_date} 
                        maxWidth={'100%'}
                        inline={false}
                        onChange={this.onDateChange.bind(this,'begin_used_date')}
                      />
                    </FormGroup>
                    <FormGroup
                      controlId={null}
                      validationState={null}
                    >
                      <ControlLabel>วันที่ถอดไว้ที่คลัง</ControlLabel>
                      <DatePicker
                        showIcon={true}
                        showFooter={true}
                        popPlacement='bottom'
                        buddhistEra
                        value={dataSet.in_stock_date} 
                        maxWidth={'100%'}
                        inline={false}
                        onChange={this.onDateChange.bind(this,'in_stock_date')}
                      />
                    </FormGroup>
                    <FormGroup
                      controlId={null}
                      validationState={null}
                    >
                      <ControlLabel>ทะเบียนรถที่ใช้ยางครั้งสุดท้าย</ControlLabel>
                      <FormControl value={dataSet.vehicle_registration_no} onChange={this.onTextChange.bind(this,'vehicle_registration_no')} />
                    </FormGroup>
                  </Form>
                </Col>
                <Col md={6} style={{ display: (dataSet.itemnum > 0) ? 'block' : 'none' }}>
                  <Form>
                    <FormGroup
                      controlId={null}
                      validationState={null}
                    >
                      <ControlLabel>{messages['Illustration']} <Button bsStyle='link' onClick={this.onUploadClick.bind(this)}>{messages['Upload']}</Button></ControlLabel>
                      <div className="box-up-img" onClick={this.onImgClick.bind(this)}>
                        <div style={{ padding: "5px" }}>
                          {this.renderImage()}
                        </div>
                      </div>
                    </FormGroup>
                  </Form>
                </Col>
              </Row>
            </div>
          {/* </Modal.Body>
          <Modal.Footer>
            <Button className="btn-primary" onClick={this.onProductSaveClick.bind(this)}>
              <FontAwesome name='save' /> {messages['Save']}
            </Button>
            <Button onClick={this.onStockEditProductCloseClick.bind(this)}>
              <FontAwesome name='remove' /> {messages['Cancel']}
            </Button>
          </Modal.Footer>
        </Modal> */}
          </Box.Body>
          <Box.Footer>
            <ButtonToolbar className='pull-right'>
                <Button className="btn-primary" onClick={this.onProductSaveClick.bind(this)}>
                    <FontAwesome name='save' /> {messages['Save']}
                </Button>
            </ButtonToolbar>
          </Box.Footer>
        </Box>
        {this.renderNewCategoryPopup()}
        <IframeModal 
            ref='iframe' 
            title={messages['Upload Image']} 
            modal={true} 
            onUpImgHide={this.onUpImgHide.bind(this)}
        />
        <NotificationSystem ref="notificationSystem" />
        <Lightbox
          currentImage={this.state.currentImage}
          images={images}
          isOpen={this.state.lightboxIsOpen}
          onClickImage={this.onClickImage.bind(this)}
          onClickNext={this.onClickNext.bind(this)}
          onClickPrev={this.onClickPrevious.bind(this)}
          onClose={this.onCloseLightbox.bind(this)}
        />
      </div>
    )
  }
}

StockEditTyreModal.defaultProps = {
  
}

export default StockEditTyreModal = connect(
  (state) => ({messages: state.message.view.tyre.stock.StockEditTyreModal}),null,null,{withRef:true}
)(StockEditTyreModal);



// WEBPACK FOOTER //
// ./src/view/tyre/stock/StockEditTyreModal.js